import LoadingAnimation from "../../componets/loader/loader";
import { API } from "../../config/api";
import { DELETE, GET, POST } from "../../utils/apicalls";
import {
  Button,
  Card,
  Form,
  Input,
  Modal,
  notification,
  Space,
  Table,
} from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function CoreValues() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [coreValuesdata, setcorevaluesData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const fetchCorevalues = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.CORE_VALUES, {});
      setcorevaluesData(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCorevalues();
  }, []);

  const handleDelete = async (id: any) => {
    try {
      setIsLoading(true);
      const delete_customer_url = `${API.DELETE_ONE_CORE_VALUES}${id}`;
      const data: any = await DELETE(delete_customer_url);

      if (data.status) {
        notification.success({ message: "Review deleted successfully!" });
        fetchCorevalues();
      } else {
        notification.error({
          message: "Something went wrong! Please try again later.",
        });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDelete = (id: any) => {
    const confirm = window.confirm(
      "Are you sure you want to delete this review?"
    );
    if (confirm) {
      handleDelete(id);
    }
  };


  // Handle form submission
  const submitHandler = async (values: any) => {
    try {
      let obj = {
        coreValuesCaption: values.coreValuesCaption,
        coreValuesDescription: values.coreValuesDescription,
      };

      setIsLoading(true);
      const postRequest: any = await POST(API.CREATE_CORE_VALUES, obj);
      if (postRequest.status) {
        notification.success({ message: "Banner added successfully!" });
        // Reset form and states
        form.resetFields();

        fetchCorevalues(); // Fetch updated list
        setIsModalOpen(false); // Close modal
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "coreValuesCaption", dataIndex: "coreValuesCaption", render: (text: any) => (
        <div style={{
          width: "100px",


        }}>
          {text}
        </div>)
    },
    {
      title: "Core Values Description",
      dataIndex: "coreValuesDescription",

      render: (text: any) => (
        <div style={{
          width: "580px",


        }}>
          {text}
        </div>)
    }

    ,
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <Space size="middle">
          <Button type="link" onClick={() => confirmDelete(record.id)}>Delete</Button>
          <Button
            type="link"
            onClick={() =>
              navigate(`/Admin/adminCore/updatecorevalues/${record.id}`)
            }
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      {" "}
      <div>
        <div className="banner-container">
          {isLoading ? (
            <LoadingAnimation />
          ) : (
            <div className="banner-content">
              <h1 className="banner-title">Core Values </h1>
              <button
                className="banner-button"
                onClick={() => setIsModalOpen(true)}
              >
                Create Core Values
              </button>
            </div>
          )}
        </div>

        <div className="w-full px-4">
          <Card className="w-full">
            {isLoading ? (
              <LoadingAnimation />
            ) : (
              <div className="overflow-x-auto">
                <Table
                  columns={columns}
                  dataSource={coreValuesdata}
                  loading={isLoading}
                  pagination={{ pageSize: 5 }}
                  scroll={{ x: "max-content" }}
                />
              </div>
            )}
          </Card>
        </div>

        <Modal
          title="Add Core values"
          visible={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          width="90%"
        >
          <Form form={form} onFinish={submitHandler} layout="vertical">
            <Form.Item
              name="coreValuesCaption"
              label="coreValuesCaption"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="coreValuesDescription"
              label="coreValuesDescription"
              rules={[{ required: true }]}
            >
              <Input.TextArea />
            </Form.Item>

            <Button type="primary" htmlType="submit" block>
              Submit
            </Button>
          </Form>
        </Modal>
      </div>
    </div>
  );
}

export default CoreValues;
